import React from "react";
import styles from "./ChooseDecisionHeader.module.scss";
import { ReactComponent as ChevronIcon } from "./chevron.svg";
import { useNavigate } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import { useProject } from "../../../../utils/utility";
const ChooseDecisionHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { project } = useProject();
  const { decisionId } = useParams();

  return (
    <div
      className={styles.header}
      style={{
        backgroundImage: `url(https://res.cloudinary.com/talaash/image/upload/v1676390506/Header_ws5ree.png)`,
      }}
    >
      <div className={styles.container}>
        <button
          className={styles.button}
          onClick={() => {
            // Navigate to option criteria screen.
            if (location.state?.screen === "option_criteria") {
              navigate(`/${project}/${decisionId}/option-comparison`)
            } else if (location?.state?.screen === "dashboard") {
              // Navigate directly to dashboard
              navigate(`/${project}`);
            } else if (decisionId) {
              navigate(`/${project}/${decisionId}`);
            } else {
              navigate(`/${project}`);
            }
          }}
        >
          <ChevronIcon />
        </button>
        <div className={styles.title}>
          {location?.pathname.includes(`/${project}/edit-decision`)
            ? "Edit Decision"
            : "Create Decision"}
        </div>
      </div>
    </div>
  );
};

export default ChooseDecisionHeader;
